var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "fab-item" },
    [
      _c("div", { staticClass: "first" }, [
        _c("div", { staticClass: "icon" }, [
          _c("img", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: true,
                expression: "true",
              },
            ],
            staticClass: "fab-icon",
            attrs: {
              src: "/static/img/fabImages/" + _vm.clone.type + "Icon.svg",
              height: "40px",
              width: "40px",
            },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "texts" }, [
          _c("div", { staticClass: "feature-title title-color" }, [
            _vm._v(
              "\n                " +
                _vm._s(_vm.metas[_vm.clone.type].title) +
                "\n            "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "feature-description" }, [
            _vm._v(
              "\n                " +
                _vm._s(_vm.metas[_vm.clone.type].description) +
                "\n            "
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "second" },
        [
          !_vm.clone.enable
            ? _c(
                "a-button",
                {
                  attrs: {
                    ghost: "",
                    type: "primary",
                    disabled: !_vm.isFabsActive,
                  },
                  on: { click: _vm.connect },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("settings.connected")) +
                      "\n        "
                  ),
                ]
              )
            : _c(
                "div",
                {
                  class: {
                    "text-success": _vm.isFabsActive,
                    "d-none": !_vm.isFabsActive,
                  },
                },
                [
                  _c("a-icon", { attrs: { type: "check" } }),
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("settings.connected")) +
                      "\n        "
                  ),
                ],
                1
              ),
          _vm._v(" "),
          _vm.clone.enable
            ? _c(
                "a-button",
                {
                  attrs: {
                    ghost: "",
                    type: "danger",
                    disabled: !_vm.isFabsActive,
                  },
                  on: {
                    click: function ($event) {
                      _vm.clone.enable = false
                    },
                  },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("settings.remove")) +
                      "\n        "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.clone.enable && _vm.isEditableFab()
            ? _c(
                "a-button",
                {
                  attrs: {
                    ghost: "",
                    type: "primary",
                    disabled: !_vm.isFabsActive,
                  },
                  on: {
                    click: function ($event) {
                      _vm.showModal = true
                    },
                  },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("settings.edit")) +
                      "\n        "
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.showModal
        ? _c(
            "Modal2",
            {
              attrs: {
                "show-footer": "",
                "ok-text": _vm.$t("common.save"),
                title: _vm.metas[_vm.clone.type].modalTitle,
                description: _vm.metas[_vm.clone.type].modalDescription,
              },
              on: {
                cancel: function ($event) {
                  _vm.showModal = false
                },
                ok: function ($event) {
                  _vm.showModal = false
                },
              },
            },
            [
              _vm.clone.type === "whatsapp"
                ? _c("WhatsappActionForm", {
                    model: {
                      value: _vm.clone,
                      callback: function ($$v) {
                        _vm.clone = $$v
                      },
                      expression: "clone",
                    },
                  })
                : _vm.clone.type === "phone"
                ? _c("PhoneActionForm", {
                    model: {
                      value: _vm.clone,
                      callback: function ($$v) {
                        _vm.clone = $$v
                      },
                      expression: "clone",
                    },
                  })
                : _vm.clone.type === "email"
                ? _c("EmailActionForm", {
                    model: {
                      value: _vm.clone,
                      callback: function ($$v) {
                        _vm.clone = $$v
                      },
                      expression: "clone",
                    },
                  })
                : _vm.clone.type === "facebook"
                ? _c("FacebookActionForm", {
                    model: {
                      value: _vm.clone,
                      callback: function ($$v) {
                        _vm.clone = $$v
                      },
                      expression: "clone",
                    },
                  })
                : _vm.clone.type === "twitter"
                ? _c("TiwitterActionForm", {
                    model: {
                      value: _vm.clone,
                      callback: function ($$v) {
                        _vm.clone = $$v
                      },
                      expression: "clone",
                    },
                  })
                : _vm.clone.type === "instagram"
                ? _c("InstagramActionForm", {
                    model: {
                      value: _vm.clone,
                      callback: function ($$v) {
                        _vm.clone = $$v
                      },
                      expression: "clone",
                    },
                  })
                : _vm.clone.type === "youtube"
                ? _c("YouTubeActionForm", {
                    model: {
                      value: _vm.clone,
                      callback: function ($$v) {
                        _vm.clone = $$v
                      },
                      expression: "clone",
                    },
                  })
                : _vm.clone.type === "linkedin"
                ? _c("Linkedin", {
                    model: {
                      value: _vm.clone,
                      callback: function ($$v) {
                        _vm.clone = $$v
                      },
                      expression: "clone",
                    },
                  })
                : _vm.clone.type === "telegram"
                ? _c("Telegram", {
                    model: {
                      value: _vm.clone,
                      callback: function ($$v) {
                        _vm.clone = $$v
                      },
                      expression: "clone",
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }